'use client'

import type React from 'react'
import { useModals, useSearchParams } from '@/lib/hooks'

import { Dialog, DialogContent } from '@/components/ui'
import { EmailReceipt } from '@/components/forms'

interface EmailReceiptModalProps extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const EmailReceiptModal = ({ open }: EmailReceiptModalProps) => {
  const { closeModal } = useModals()
  const { orderId } = useSearchParams()

  return (
    <Dialog open={open}>
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('EMAIL_RECEIPT')}
        size="md"
        className="min-h-[200px]"
      >
        <EmailReceipt orderId={orderId} />
      </DialogContent>
    </Dialog>
  )
}
